export default {"src":"https://fishbrain.com/_next/static/media/northCarolina.0a87b326.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};